/**
 * Preview WhatsApp ao vivo — render puro de `components[]` (FE puro).
 *
 * Espelha o WhatsAppPreview do gabarito: balão com header/body/footer + botões,
 * substituindo `{{n}}` por valores de exemplo. Cores são da paleta própria do
 * WhatsApp (literais intencionais — não tokens do DS, pois imitam o app).
 */

import { renderPreviewBody } from './template-helpers';

import type { FlatTemplate } from './template-helpers';

interface WhatsAppPreviewProps {
  brand: string;
  flat: FlatTemplate;
  approved: boolean;
}

export function WhatsAppPreview({ brand, flat, approved }: WhatsAppPreviewProps): JSX.Element {
  return (
    <div className="mt-wa">
      <div className="mt-wa__brand">{brand}</div>
      <div className="mt-wa__bubble">
        {flat.header.length > 0 && <div className="mt-wa__header">{flat.header}</div>}
        <div className="mt-wa__body">{renderPreviewBody(flat.body)}</div>
        {flat.footer.length > 0 && <div className="mt-wa__footer">{flat.footer}</div>}
        <div className="mt-wa__time">14:32 · {approved ? '✓✓' : '·'}</div>
      </div>
      {flat.buttons.length > 0 && (
        <div className="mt-wa__buttons">
          {flat.buttons.map((b, i) => (
            <div key={`${b.text}-${i}`} className="mt-wa__btn">
              {b.text}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
